import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpError } from '@shared/utils/models/http.model';
import { catchError, of, forkJoin, mergeMap, switchMap } from 'rxjs';
import { Action } from '@ngrx/store';
import { UserActions } from '../actions/user.actions';
import { LinkService } from '../services/link.service';
import { LinkActions } from '../actions/link.action';

@Injectable()
export class LinkEffects {
  private readonly linkService = inject(LinkService);
  private readonly actions$ = inject(Actions);

  bulkUpdateLinks$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LinkActions.bulkUpdateLinks),
      mergeMap((action) =>
        forkJoin([
          action.add.length ? this.linkService.addLinks(action.add) : of(null),
          action.delete.length ? this.linkService.deleteLinks(action.delete.map(({ id }) => id)) : of(null),
        ]).pipe(
          switchMap((response) => {
            const actions: Action[] = [LinkActions.bulkUpdateLinksSuccess({ add: action.add, delete: action.delete })];
            if (response.some(Boolean)) {
              actions.push(UserActions.getProfile());
            }
            return actions;
          }),
          catchError((error: HttpError) => of(LinkActions.bulkUpdateLinksFailure({ error })))
        )
      )
    );
  });

  bulkUpdateSocialMediaLinks$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LinkActions.bulkUpdateSocialMediaLinks),
      mergeMap((action) =>
        forkJoin([
          action.add.length || action.delete.length
            ? this.linkService.addSocialMediaLinks(
                action.add,
                action.delete.map(({ id }) => id)
              )
            : of(null),
        ]).pipe(
          switchMap((response) => {
            const actions: Action[] = [LinkActions.bulkUpdateSocialMediaLinksSuccess()];
            if (response.some(Boolean)) {
              actions.push(UserActions.getProfile());
            }
            return actions;
          }),
          catchError((error: HttpError) => of(LinkActions.bulkUpdateSocialMediaLinksFailure({ error })))
        )
      )
    );
  });
}
